import { sassNull } from 'sass'
import apiManager from './apiManager'
// ? create new Incident
// param queryObj { memberId , name, address1, address2, district, city, state, area, type, division, areaUnit }

const createIncident = async (queryObj) => {
	const incidentCreate = apiManager.axios
		.post('/v1/admin/incident', {
			name: queryObj.name,
			email: queryObj.email,
			phone: queryObj.phone,
			title: queryObj.title,
			note: queryObj.note,
			priority: queryObj.priority,
			isPublished: queryObj.isPublished,
			company: queryObj.company,
			project: queryObj.project,
			jobs: queryObj.jobs,
			skills: queryObj.skills,
			certificates: queryObj.certificates,
			relatedIncidentId: queryObj.relatedIncidentId,
			userId: queryObj.userId ? queryObj.userId : null,
			incidentId: queryObj.incidentId ? queryObj.incidentId : null,
			type: queryObj.type,
		})
		.then((response) => {
			return response
		})
		.catch((err) => {
			console.error(err)
			return {
				status: err.response.status,
			}
		})

	return incidentCreate
}

const createEsgIncident = async (queryObj) => {
	const incidentCreate = apiManager.axios
		.post('/v1/admin/incident/esg', {
			name: queryObj.name,
			email: queryObj.email,
			phone: queryObj.phone,
			note: queryObj.note,
			priority: queryObj.priority,
			isPublished: queryObj.isPublished,
			company: queryObj.company,
			project: queryObj.project ? queryObj.project : 'test',
			companyType: queryObj.organizationType,
			workType: queryObj.workType,
			jobs: queryObj.jobs,
			skills: queryObj.skills,
			relatedIncidentId: queryObj.relatedIncidentId,
			userId: queryObj.userId ? queryObj.userId : null,
			incidentId: queryObj.incidentId ? queryObj.incidentId : null,
			type: 'esg',
		})
		.then((response) => {
			return response
		})
		.catch((err) => {
			console.error(err)
			return {
				status: err.response.status,
			}
		})
	return incidentCreate
}

const dispatchIncidentWithAgent = async (queryObj, jobDetail, agentId) => {
	var jobs = [...queryObj.jobs]
	if (queryObj.relatedIncidentId) {
		var relatedIncidentId = [...queryObj.relatedIncidentId]
	}

	if (
		jobDetail.description &&
		jobDetail.wages &&
		jobDetail.workingPeriod &&
		jobDetail.address &&
		jobDetail.dueDate
	) {
		jobs.push(jobDetail)
	}

	const dispatchIncident = apiManager.axios
		.post(`/v1/admin/incident/createIncidentWithApprovedAgent`, {
			id: queryObj.id,
			title: queryObj.title,
			description: queryObj.description,
			note: queryObj.note,
			priority: queryObj.priority,
			name: queryObj.name,
			email: queryObj.email,
			type: queryObj.type,
			project: queryObj.project,
			company: queryObj.company,
			phone: queryObj.phone,
			skills: queryObj.skills,
			certificates: queryObj.certificates,
			jobs: jobs,
			isPublished: queryObj.isPublished,
			relatedIncidentId: relatedIncidentId,
			userId: agentId,
		})
		.then((response) => {
			return response
		})
		.catch((err) => {
			console.error(err)
			return {
				status: err.response.status,
			}
		})
	return dispatchIncident
}

const publishIncidentWithAgent = async (
	queryObj,
	jobDetail,
	id = Null,
	agentId
) => {
	var jobs = [...queryObj.jobs]
	if (queryObj.relatedIncidentId) {
		var relatedIncidentsId = [...queryObj.relatedIncidentId]
	}

	if (
		jobDetail.description &&
		jobDetail.wages &&
		jobDetail.workingPeriod &&
		jobDetail.address &&
		jobDetail.dueDate
	) {
		jobs.push(jobDetail)
	}
	const draftCreateIncidentWithAgent = apiManager.axios
		.patch(`/v1/admin/incident/${id}/publishIncidentWithApprovedAgent`, {
			// ...queryObj,
			title: queryObj.title,
			note: queryObj.note,
			description: queryObj.description,
			priority: queryObj.priority,
			project: queryObj.project,
			company: queryObj.company,
			type: queryObj.type,
			name: queryObj.name,
			email: queryObj.email,
			phone: queryObj.phone,
			skills: queryObj.skills,
			certificates: queryObj.certificates,
			jobs: jobs,
			isPublished: queryObj.isPublished,
			relatedIncidentId: relatedIncidentsId,
			userId: agentId,
		})
		.then((response) => {
			return response
		})
		.catch((err) => {
			console.error(err)
			return {
				status: err.response.status,
			}
		})

	return draftCreateIncidentWithAgent
}
const createNewIncident = async (queryObj, jobDetail) => {
	var jobs = [...queryObj.jobs]
	if (queryObj.relatedIncidentId) {
		var relatedIncidentId = [...queryObj.relatedIncidentId]
	}
	if (
		jobDetail.description &&
		// jobDetail.wages &&
		jobDetail.workingPeriod &&
		// jobDetail.address &&
		jobDetail.dueDate
	) {
		jobs.push(jobDetail)
	}

	const incidentCreate = apiManager.axios
		.post(`/v1/admin/incident`, {
			// ...queryObj,
			id: queryObj.id,
			title: queryObj.title,
			description: queryObj.description,
			note: queryObj.note,
			type: queryObj.type,
			priority: queryObj.priority,
			project: queryObj.project,
			company: queryObj.company,
			name: queryObj.name,
			email: queryObj.email,
			certificates: queryObj.certificates,
			phone: queryObj.phone,
			skills: queryObj.skills,
			jobs: jobs,
			isPublished: queryObj.isPublished,
			relatedIncidentId: relatedIncidentId,
		})
		.then((response) => {
			return response
		})
		.catch((err) => {
			console.error(err)
			return {
				status: err.response.status,
			}
		})

	return incidentCreate
}
const getAllIncidents = async (pageNumber = 1) => {
	const allIncidents = apiManager.axios
		.get(`/v1/admin/incident?page=${pageNumber}`)
		.then((response) => {
			return { status: 200, data: response.data }
		})
		.catch((err) => {
			return {
				status: err.response.status,
			}
		})

	return allIncidents
}

const getFilteredIncidentList = async (status, priority) => {
	const filteredIncidents = apiManager.axios
		.get(`/v1/admin/incident`, {
			params: {
				...(status && { status }),
				...(priority && { priority }),
			},
		})
		.then((response) => {
			return { status: 200, data: response.data }
		})
		.catch((err) => {
			return {
				status: err.response.status,
			}
		})
	return filteredIncidents
}

const getSingleIncident = async (id) => {
	const oneIncident = apiManager.axios
		.get(`/v1/admin/incident/${id}`)
		.then((response) => {
			return { status: 200, data: response.data }
		})
		.catch((err) => {
			return {
				status: err.response.status,
			}
		})

	return oneIncident
}

const getRelatedIncident = async (id) => {
	const relatedIncident = apiManager.axios
		.get(`/v1/admin/incident/${id}/relatedIncidents`)
		.then((response) => {
			return { status: 200, data: response.data }
		})
		.catch((err) => {
			return {
				status: err.response.status,
			}
		})

	return relatedIncident
}

const deleteIncident = async (id) => {
	const deleteIncident = apiManager.axios
		.delete(`/v1/admin/incident/${id}`)
		.then((response) => {
			return { status: 200, data: response.data }
		})
		.catch((err) => {
			return {
				status: err.response.status,
			}
		})
	return deleteIncident
}

const completeIncident = async (id, incidentFeedback) => {
	return await apiManager.axios
		.patch(`/v1/admin/incident/${id}`, { incidentFeedback })
		.then((response) => {
			return { status: 200, data: response.data.data }
		})
		.catch((err) => {
			return {
				status: err.response.status,
			}
		})
}
const reviewIncident = async (id) => {
	return await apiManager.axios
		.patch(`/v1/admin/incident/${id}/reviewIncident`)
		.then((response) => {
			return { status: 200, data: response.data.data }
		})
		.catch((err) => {
			return {
				status: err.response.status,
			}
		})
}

const PublishDraftIncident = async (queryObj, jobDetail, id = null) => {
	var jobs = [...queryObj.jobs]
	if (queryObj.relatedIncidentId) {
		var relatedIncidentsId = [...queryObj.relatedIncidentId]
	}

	if (
		jobDetail.description &&
		jobDetail.wages &&
		jobDetail.workingPeriod &&
		jobDetail.address &&
		jobDetail.dueDate
	) {
		jobs.push(jobDetail)
	}
	const draftCreateIncident = apiManager.axios
		.put(`/v1/admin/incident/${id}`, {
			// ...queryObj,
			title: queryObj.title,
			note: queryObj.note,
			description: queryObj.description,
			priority: queryObj.priority,
			name: queryObj.name,
			email: queryObj.email,
			project: queryObj.project,
			phone: queryObj.phone,
			skills: queryObj.skills,
			certificates: queryObj.certificates,
			jobs: jobs,
			isPublished: queryObj.isPublished,
			relatedIncidentId: relatedIncidentsId,
		})
		.then((response) => {
			return response
		})
		.catch((err) => {
			console.error(err)
			return {
				status: err.response.status,
			}
		})

	return draftCreateIncident
}

const getContactSuggestion = async (phoneNumber) => {
	const contactSuggestion = apiManager.axios
		.post(`/v1/admin/client/searchClient`, {
			startDigits: phoneNumber, // Sending the partial phone number in the request body
		})
		.then((response) => {
			return { status: 200, data: response.data.data }
		})
		.catch((err) => {
			console.log(err)
		})
	return contactSuggestion
}
export default {
	createIncident,
	createEsgIncident,
	createNewIncident,
	getAllIncidents,
	getSingleIncident,
	deleteIncident,
	completeIncident,
	PublishDraftIncident,
	reviewIncident,
	getRelatedIncident,
	dispatchIncidentWithAgent,
	publishIncidentWithAgent,
	getContactSuggestion,
	getFilteredIncidentList,
}
